import React from "react";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Button, IconButton, Stack, Typography } from "@mui/material";

interface Props {
  onRefresh: () => Promise<void>;
  onClose: () => void;
}

export const UpdateBar: React.FC<Props> = ({ onRefresh, onClose }) => {
  return (
    <Stack
      direction="row"
      sx={{
        flexShrink: 0,
        maxHeight: "100%",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "space-between",
        height: 60,
        bgcolor: "#68babf",
        p: "0 20px",
        width: "100%"
      }}
    >
      <Typography sx={{ fontSize: "16px", color: "white" }}>
        The file data has been updated, please refresh to see changes
      </Typography>
      <Stack flexDirection="row" sx={{ justifyContent: "center", alignItems: "center" }} gap="10px">
        <Button sx={{ color: "white", borderColor: "white" }} variant="outlined" onClick={onRefresh}>
          Refresh
        </Button>
        <IconButton onClick={onClose}>
          <CloseOutlinedIcon sx={{ fill: "white", fontSize: "18px", cursor: "pointer" }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
